import React from 'react';
import { Hero } from './components/Hero';
import { PainAndProduct } from './components/PainProduct';
import { TomosAndBonos } from './components/TomosBonos';
import { Precios } from './components/Precios';
import { TestimonialsAndFaq } from './components/TestimonialsFaq';
import { CtaAndFooter } from './components/Footer';
import { StickyCTA } from './components/Shared';
import { SocialProofToast } from './components/SocialProofToast';
import { UrgencyBanner } from './components/UrgencyBanner';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-base font-sans text-brand-text selection:bg-brand-orange selection:text-white pb-20 md:pb-0" data-id="element-0" data-mp="31aqeoda66opo">
      <MetaPixel data-id="element-1" data-mp="2wiywor52xrb5" />
      <UrgencyBanner data-id="element-2" data-mp="2wifgpfyzpczr" />
      <main data-id="element-3" data-mp="2whxd1y9zzwht">
        <Hero data-id="element-4" data-mp="28ufo0ai4bcij" />
        <PainAndProduct data-id="element-5" data-mp="28tw62tsgwo4i" />
        <TomosAndBonos data-id="element-6" data-mp="28te4dhn1dhp7" />
        <Precios data-id="element-7" data-mp="28sl4n0mhvsgk" />
        <TestimonialsAndFaq data-id="element-8" data-mp="28s2zfehuu3wi" />
      </main>
      <CtaAndFooter data-id="element-9" data-mp="23w4ek0vqj40u" />
      <StickyCTA data-id="element-10" data-mp="23utcc5hxu4bu" />
      <SocialProofToast data-id="element-11" data-mp="23t8heerpojdg" />
    </div>;
}